import {Box, Skeleton} from '@chakra-ui/react';

export const ProviderHeadSkeleton = () => {
  return (
    <Box w="100%">
      <Skeleton height={['225px', '452px']} mb={['10px', '25px']} mt="30px" borderRadius="16px" />
    </Box>
  );
};
